// Persisted production/stringing data uses designer roof indices. Segment-only
// selected_panel_count is transient: the legacy Segment API does not store it.
export function getPersistedPanelCounts(stringingData, productionPerPanelData) {
  const selected = new Map();
  if (Array.isArray(stringingData)) {
    stringingData.forEach((string) => {
      if (!Array.isArray(string?.panels)) return;
      string.panels.forEach((pair) => {
        if (!Array.isArray(pair) || pair.length < 2) return;
        const [roof, panel] = pair;
        if (!Number.isInteger(roof) || roof < 0 || !Number.isInteger(panel) || panel < 0) return;
        if (!selected.has(roof)) selected.set(roof, new Set());
        selected.get(roof).add(panel);
      });
    });
  }
  if (selected.size) {
    return new Map([...selected].map(([roof, panels]) => [roof, panels.size]));
  }
  if (!Array.isArray(productionPerPanelData)) return null;
  const counts = new Map();
  productionPerPanelData.forEach((roof) => {
    if (!Number.isInteger(roof?.idx) || roof.idx < 0 || !Array.isArray(roof.roofPanels)) return;
    counts.set(roof.idx, roof.roofPanels.filter((value) => Number.isFinite(Number(value)) && Number(value) > 0).length);
  });
  return counts.size ? counts : null;
}
